import {post, postfile, downFile} from './http'
const baseUrl = '/api/admin/shopMgt/pc'
const shopUrl = '/api/shop/product/content'
// /api/admin/shopMgt/pc/getActList 活动列表
export const getActivityList = v => post(`${baseUrl}/getActList`, v.data, v.success, v.error)
// 星球列表 /api/admin/shopMgt/pc/getStarList
export const getStarList = v => post(`${baseUrl}/getStarList`, v.data, v.success, v.error)

// 获取商品内容基本信息详情
export const getProductDetail = v => post(`${shopUrl}/getProductDetail`, v.data, v.success, v.error)

// 星球话题列表
export const getStarTopicPageList = v => post(`${baseUrl}/getStarTopicPageList`, v.data, v.success, v.error)
// 星球默认和精华
export const getStarSbjectList = v => post(`${baseUrl}/getStarSbjectList`, v.data, v.success, v.error)
